import { useForm } from "react-hook-form";
import { Accordion, AccordionDetails, AccordionSummary, Switch } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

export default function TransportistaCambioForm({ venta, onTransportistaChange }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    getValues,
    watch
  } = useForm({
    defaultValues: {},
  });
  const transportistas = useSelector(state => {
    return state.transportistas
  });
  const serviciosEnvio = useSelector(state => {
    return state.servicios_envio;
  });
  const [uniqueEnvios, setUniqueEnvios] = useState(null);
  const [changeTransportista, setChangeTransportista] = useState(false);

  useEffect(() => {
    const enviosData = {};

    venta.envios?.forEach((envio) => {
      enviosData[envio.id] = {
        url_seguimiento: envio.url_seguimiento || '',
        numero_seguimiento: envio.numero_seguimiento === '-' ? '' : envio.numero_seguimiento,
        codigo_transporte: envio.codigo_transporte,
        transportista_id: envio.transportista_id,
        servicio_envio_id: envio.servicio_envio_id,
      };
    });

    setUniqueEnvios(enviosData);
    reset({ envios: enviosData });
  }, [venta.envios, reset]);

  const handleSubmitVentaInfo = (data, e) => {
    e.preventDefault();

    const changedEnvios = Object.entries(data.envios)
      .filter(([id, envio]) => {
        const original = uniqueEnvios[parseInt(id)];
        if (!original) return false;
        const url = envio.url_seguimiento;
        const numSeguimiento = envio.numero_seguimiento === "" ? '-' : envio.numero_seguimiento;

        return (
          (original.url_seguimiento !== url) ||
          (original.numero_seguimiento !== numSeguimiento) ||
          (original.transportista_id !== envio.transportista_id) ||
          (original.servicio_envio_id !== envio.servicio_envio_id)
        );
      })
      .map(([id, envio]) => ({
        id: parseInt(id),
        ...envio
      }));

    onTransportistaChange(changedEnvios);
  };


  return (
    <form className="form w-100" onSubmit={handleSubmit(handleSubmitVentaInfo)}>
      {venta?.envios?.map((envio) => (
        <Accordion key={envio.id} className="w-100">
            <AccordionSummary
                aria-controls="envios-content"
                id="envios"
            >
                <p className={"fw-bold " + (envio.numero_seguimiento !== '-' ? 'text-green' : 'text-danger')}>{envio.codigo_transporte}</p>
            </AccordionSummary>
            <AccordionDetails>
                <div className="w-100 d-flex flex-column">
                    <div className="w-100 d-flex align-items-center">
                        <Switch
                            color="success"
                            checked={changeTransportista}
                            onChange={(e) => setChangeTransportista(e.target.checked)}
                            inputProps={{ 'aria-label': 'controlled' }} /> 
                        <label>Cambio de transportista?</label>
                    </div>
                    
                    <div>
                        <div className="w-100">
                            {envio.transportista_id === 1 && (
                            <>
                                <div className="form-group mb-0">
                                <label htmlFor="url_seguimiento">URL de seguimiento:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register(`envios.${envio.id}.url_seguimiento`)}
                                />
                                </div>
                            
                                <div className="form-invalid">
                                {errors.envios?.[envio.id]?.url_seguimiento && 'La URL de seguimiento es obligatoria'}
                                </div>
                            </>
                            )}
                        </div>
                        <div className="w-100">
                            <div className="form-group mb-0 mt-3">
                            <label htmlFor="numero_seguimiento">Número de seguimiento:</label>
                            <input
                                type="text"
                                className="form-control"
                                {...register(`envios.${envio.id}.numero_seguimiento`)}
                            />
                            </div>
                            <div className="form-invalid">
                            {errors.envios?.[envio.id]?.numero_seguimiento && 'El número de seguimiento es obligatorio'}
                            </div>
                        </div>
                    </div>

                    { (changeTransportista) &&
                        <div className='mt-4'>
                        <div className="form-group">
                            <label>Nuevo transportista:</label>
                            <select 
                                id={`envios.${envio.id}.transportista_id`}
                                defaultValue={envio.transportista_id}
                                {...register(`envios.${envio.id}.transportista_id`, { required: true })}
                                onChange={(e) => setValue(`envios.${envio.id}.transportista_id`, e.target.value)}>
                                {transportistas?.map(op => <option key={'transportista-' + op.id} value={op.id}>{op.nombre}</option>)}
                            </select>
                        </div>
                        { watch(`envios.${envio.id}.transportista_id`) &&
                        <div className="form-group">
                            <label>Nuevo servicio de envío:</label>
                            <select 
                                id={`envios.${envio.id}.servicio_envio_id`}
                                defaultValue={envio.servicio_envio_id}
                                {...register(`envios.${envio.id}.servicio_envio_id`, { required: true })}
                                onChange={(e) => setValue(`envios.${envio.id}.servicio_envio_id`, e.target.value)}>
                                {serviciosEnvio.filter(sv => sv.transportista_id == getValues(`envios.${envio.id}.transportista_id`))
                                ?.map(op => <option key={'servicioenvio-' + op.id} value={op.id}>{op.nombre}</option>)}
                            </select>
                        </div>
                        }
                        </div>
                    }
                </div>
            </AccordionDetails>
        </Accordion>
        ))}

      <div className="d-flex align-items-center justify-content-end w-100 mt-3">
        <button type="submit" className="btn btn-primary">
          Guardar
        </button>
      </div>
    </form>
  );
}
